import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const CEREBRO_SUPABASE_URL = import.meta.env.VITE_CEREBRO_SUPABASE_URL;
const CEREBRO_SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_CEREBRO_SUPABASE_PUBLISHABLE_KEY;

export const CEREBRO_AUTH_STORAGE_KEY = 'forjahub-2:cerebro-auth';

if (!CEREBRO_SUPABASE_URL || !CEREBRO_SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    'Configure VITE_CEREBRO_SUPABASE_URL and VITE_CEREBRO_SUPABASE_PUBLISHABLE_KEY.',
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(CEREBRO_SUPABASE_URL, CEREBRO_SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    storageKey: CEREBRO_AUTH_STORAGE_KEY,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});
